import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAllAreas(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('talento-humano/areas'), opciones);
  },
  async findAllCargosPorArea(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`talento-humano/areas/${id}/cargos`));
  },
  async findAllSedes(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('talento-humano/sedes'), opciones);
  },
};
